<template>
	 <div class="animated fadeIn">
    <b-row>
      <b-col sm="9" md="9">
        <b-row>
          <b-col sm="9" md="9">
            <div class="card text-black border-info mb-3">
              <div class="card-header bg-info">
                <div class="cd-content">
                  <b>Bénéficiaire</b> : {{ contact.prenom }} {{ contact.nom }} <br>
                  <b>Sujet</b> : {{ contact.sujet }}
                </div>
              </div>
              <div class="card-body">
                <div class="cb-message">{{ contact.message }}</div>
              </div>
              <div class="card-footer">
                <div class="pull-right">
                  <span v-if="contact.hasFile">
                    <div v-for="file in contact.fileName">
                      <i class="icon-paper-clip"></i>
                      <a style="margin-left:5px" href="#" @click.prevent="download(contact.user_id,contact.id, file)">
                        {{ file }}
                      </a>
                    </div>
                  </span>
                  <span v-else>
                    <span><i>Aucune pièce envoyée</i></span>
                  </span>
                </div>
              </div>
              <div class="card-footer">
                <b-button type="button" @click="returnBack" size="md" variant="secondary">
                  <i class="fa fa-arrow-left"></i> Liste des contacts
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '@/utils/auth'
import { downloadFile } from '@/utils/fileHelper'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  data() {
	  return {
      id: '',
      file: '',
      contact : [],
      editor: ClassicEditor,
      message: '<p>Content of the editor.</p>'
	  }
	},
  mounted() {
    this.id = this.$route.params.id
    this.get()
  },
	created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
	methods: {
	  get() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      let contactId = this.$route.params.id
      this.$axios
        .get("/espaceBeneficiaire/contacts/" + contactId)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.contact = response.data.contact
          this.contact.nom = this.contact.user.nom
          this.contact.prenom = this.contact.user.prenom
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
	  },
    download(userId, contactId, fileName, ligneId) {
      let self = this;
      if (ligneId === undefined) { ligneId = null }
      let config = { 'userId': userId, 'contactId': contactId, 'fileName': fileName, 'ligneId': ligneId }
      let fileNameArr = fileName.split('.')
      let extension = fileNameArr.pop();
      let name = fileNameArr.join('.');
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .post("/espaceBeneficiaire/contacts/telechargement", config , {responseType: 'arraybuffer'}).then(response => {
          this.$store.commit("IS_LOADING", false);
          downloadFile(response, name, extension);
        })
        .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            let errorText = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI"
            if (error.response && error.response.status === 404 && self !== undefined) {
              errorText = "La piéce justificatif demandée n'existe pas"
            }
            self.$swal({
            position: "top",
            type:"error",
            title:"Attention !!",
            text:errorText,
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    returnBack() {
      // this.$router.push({ path: '/espace-beneficiaire/gestion-des-contacts' })
      this.$router.push({ path: "/espace-beneficiaire/gestion-des-contacts", query: { in: this.$route.query.in, do: this.$route.query.do, ns: this.$route.query.ns, no: this.$route.query.no, pr: this.$route.query.pr, su: this.$route.query.su }})
    }
	}
}
</script>

<style>
  .cb-message {
    font-size: 15px;
  }
  .cd-content {
    font-size: 15px;
    line-height: 30px;
  }
</style>
